import { editPermissions, addPermissions } from './request';
import { menuList } from './../menuManage/request';
export default {
  name: 'customerModel',
  props: {
    currentRow: [Object, {}],
    dialogVisible: Boolean
  },
  data() {
    return {
      dataFrom: {
        isOpen: undefined
      },
      treeData: [],
      loading: false,
      value: undefined
    };
  },
  computed: {
    roleRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('权限名称')
        }],
        associationId: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('关联权限id')
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('类型'),
          trigger: 'change'
        }],
        isOpen: [{
          required: true,
          message: this.$t('请选择') + this.$t('开放状态'),
          trigger: 'change'
        }],
        description: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('权限描述')
        }]
      };
    }
  },
  created() {
    setTimeout(() => {
      console.log(this.currentRow);
      menuList({
        isOpen: this.currentRow.isOpen
      }).then(res => {
        console.log(res);
        this.treeData = res;
      });
      if (this.currentRow.id) {
        this.dataFrom = {
          permissionsId: this.currentRow.id,
          name: this.currentRow.name,
          description: this.currentRow.description,
          associationId: this.currentRow.associationId,
          menuIds: this.currentRow.menuIds,
          type: this.currentRow.type,
          isOpen: this.currentRow.isOpen
        };
        this.value = this.currentRow.menuIds ? this.currentRow.menuIds.split(',') : undefined;
      } else {
        this.dataFrom.isOpen = this.currentRow.isOpen;
      }
      console.log(this.dataFrom);
    }, 200);
  },
  methods: {
    onChange(value) {
      this.value = value;
      this.dataFrom.menuIds = value.length != 0 ? value.join(',') : '';
    },
    handleSure() {
      this.$refs.roleFrom.validate(valid => {
        this.loading = true;
        if (valid) {
          if (this.dataFrom.permissionsId) {
            //编辑
            console.log(555);
            editPermissions(this.dataFrom).then(() => {
              this.$message.success(this.$t('修改成功'));
              this.loading = false;
              this.$emit(this.$t('ok'));
              this.$emit(this.$t('cancel'));
            });
          } else {
            //新增
            addPermissions(this.dataFrom).then(() => {
              this.$message.success(this.$t('添加成功'));
              this.loading = false;
              this.$emit(this.$t('ok'));
              this.$emit(this.$t('cancel'));
            });
          }
        } else {
          this.loading = false;
        }
      });
    }
  }
};